import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import { AppService } from '@services/app.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

declare var $: any;


@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.scss']
})
export class ClientesComponent implements OnInit {
  public nuevoForm: FormGroup;
  public editForm: FormGroup;
  public isAuthLoading = false;


  public user: any = null;
  reporteExport:any;
  findInput: any;
  clientes: any = [];
  pagesNumber: any;
  offset= 3;
  page= 1;  
  public cargando = false;


  constructor( public router: Router,private toastr: ToastrService, private appService: AppService, private http: HttpClient) { }

  ngOnInit(): void {
    this.user = this.appService.user;
    // console.log(this.user);
    this.getList();  
    
    this.nuevoForm = new FormGroup({
      nombre: new FormControl(null, Validators.required),
      cc: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.required),
      direccion: new FormControl(null, Validators.required),
      celular: new FormControl(null, Validators.required),
      ciudad: new FormControl(null, Validators.nullValidator),
      nota: new FormControl(null, Validators.nullValidator),
    });   
    
    this.editForm = new FormGroup({
      id: new FormControl(null, Validators.required),
      nombre: new FormControl(null, Validators.required),
      cc: new FormControl(null, Validators.nullValidator),
      email: new FormControl(null, Validators.nullValidator),
      direccion: new FormControl(null, Validators.nullValidator),      
      celular: new FormControl(null, Validators.nullValidator),  
      ciudad: new FormControl(null, Validators.nullValidator),
      nota: new FormControl(null, Validators.nullValidator),
    });       

  }

  getList(){
    this.appService.getClientes(this.user.et+'-'+this.page).subscribe( (data) => {
    this.clientes = data['clientes']; 
    this.ForpagesNumber();
    this.cargando = false;
    });
  }


 

  changePage(page) {
    this.page = page; //para el filtro
    this.clientes.current = page;
    this.getList();
  }
  
  ForpagesNumber() {
    let from = this.clientes.current - this.offset;
    if(from < 1){
      from = 1;
    }

    let to = from + (this.offset * 2); 
    if(to >= this.clientes.total_page){
      to = this.clientes.total_page;
    }

    let pagesArray = [];
    while(from <= to){
      pagesArray.push(from);
      from++;
    }
    this.pagesNumber = pagesArray;
    // return pagesArray;
  }

  async newCliente() {     
    if (this.nuevoForm.valid) {
        this.isAuthLoading = true; 
          let params = {
              nuevo:true,
              et: this.user.et,
              nombre: this.nuevoForm.value.nombre,
              cc: this.nuevoForm.value.cc,
              email: this.nuevoForm.value.email,
              direccion: this.nuevoForm.value.direccion,
              ciudad: this.nuevoForm.value.ciudad,
              celular: this.nuevoForm.value.celular,
              nota: this.nuevoForm.value.nota,
              estado: 1,
            };
            // console.log(params);
            this.appService.postClientes(params)
          .subscribe( (data) => {
            // console.log(data);
              if (data["logger"] == true){
                  this.nuevoForm.reset()
                  $('#offcanvasNuevaUsuario').offcanvas('hide');
                  this.toastr.success(data["msg"]);
                  this.getList();
              }else{
                  this.toastr.error(data["msg"]);
              }
          }); 
        this.isAuthLoading = false;
    } else {
        this.toastr.error('El formulario no es válido!');
    }
  }


  ver(item){
    console.log(item);
    this.editForm.get('id').setValue(item.id);
    this.editForm.get('nombre').setValue(item.nombre);
    this.editForm.get('email').setValue(item.email);
    this.editForm.get('cc').setValue(item.cc);
    this.editForm.get('direccion').setValue(item.direccion);
    this.editForm.get('celular').setValue(item.celular);
    this.editForm.get('ciudad').setValue(item.ciudad);
    this.editForm.get('nota').setValue(item.nota);
    $('#ver').modal('show');
  }

  async editUsuario(){
    if (this.editForm.valid) {
      this.isAuthLoading = true; 
        let params = {
            editar:true,
            id: this.editForm.value.id,
            nombre: this.editForm.value.nombre,
            email: this.editForm.value.email,
            direccion: this.editForm.value.direccion,
            celular: this.editForm.value.celular,
            cc: this.editForm.value.cc,
            ciudad: this.editForm.value.ciudad,
            nota: this.editForm.value.nota,
            // empresa_id: this.user.eid
          };
          // console.log(params);
          this.appService.postClientes(params)
        .subscribe( (data) => {
            if (data["logger"] == true){
              this.toastr.success(data["msg"]);
              this.editForm.reset()
              $('#ver').modal('hide');
              this.getList();
            }else{
              this.toastr.error(data["msg"]);
            }
        }); 
      this.isAuthLoading = false;
  } else {
      this.toastr.error('El formulario no es válido!');
  }
  }

  async eliminarUsuario(item){
    Swal.fire({
      title: '¿Está seguro?',
      text: `Desea eliminar al usuario?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, estoy seguro!',
    }).then((result) => {
      if (result.value) {
        // console.log('dentro true');
        
        let params = {
          eliminar : true,
          id: item.id,
          empresa_id: this.user.eid
        }
        this.appService.postUsuario(params)
        .subscribe( (data) => {
            if (data["logger"] == true){
                this.getList();
                this.toastr.success(data["msg"]);
            }else{
                this.toastr.error(data["msg"]);
            }
        });         

      }
    });  

  }


  async findCliente() {     
    let params = {
        buscar:true,
        buscar_input: this.findInput,
        page: this.page,
        et: this.user.et,
      };
        this.appService.postClientes(params)
        .subscribe( (data) => {
            if (data["logger"] == true){
              this.clientes = data['clientes']; 
            }else{
              this.toastr.error(data["msg"]);
            }
        });
  }

  async exportCliente() {     
    let params = {
        export:true,
        et: this.user.et,
      };
        this.appService.postClientes(params)
        .subscribe( (data) => {
          console.log(data['clientes']);
          
            if (data["logger"] == true){
              this.reporteExport = data['clientes'];

              const fileName = 'clientes.xlsx';
              const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.reporteExport);
        
              // ANCHO COLUMNAS
              ws['!cols'] = [ {width:2},{width:8},{width:35}, {width:35},{width:20},{width:20},{width:20},{width:20},{width:20},{width:20}];
              // ELIMINA COLUMNA1
              ws['!cols'][0] = { hidden: true };
              // ws['!cols'][1] = { hidden: true };
              // ws['!cols'][13] = { hidden: true };
              // ws['!cols'][14] = { hidden: true };
              // ws['!cols'][18] = { hidden: true };
              // // ws['G2'] = { Target:"#E2" };
              const wb: XLSX.WorkBook = XLSX.utils.book_new();
              // CAMBIA CABECERA
              XLSX.utils.sheet_add_aoa(ws, [["log","ID","NOMBRE","EMAIL","CELULAR","CIUDAD","NOMBRE"]]);
              XLSX.utils.sheet_add_json(ws, this.reporteExport, { origin: 'A2', skipHeader: true });  
        
              XLSX.utils.book_append_sheet(wb, ws, 'reporte');
              XLSX.writeFile(wb, fileName);

            }else{
              this.toastr.error(data["msg"]);
            }
        });
  }  



}
